<div class="page-inner-view" *ngIf="initiative_data">
  <table class="page-inner-table">
    <thead>
      <tr>
        <!-- <th appColumnResizable>Actions</th> -->
        <th>Actions</th>
        <!-- <th appColumnResizable>Milestone Name</th> -->
        <th>Milestone Name</th>
        <!-- <th appColumnResizable>Activities</th> -->
        <th>Activities</th>
        <!-- <th appColumnResizable>Due Date</th> -->
        <th>Due Date</th>
        <!-- <th appColumnResizable>Actual Date</th> -->
        <th>Actual Date</th>
        <!-- <th appColumnResizable>Owner</th> -->
        <th>Owner</th>
        <!-- <th appColumnResizable>Status</th> -->
        <th>Status</th>
        <!-- <th appColumnResizable>Priority</th> -->
        <th>Priority</th>
        <!-- <th appColumnResizable>Description</th> -->
        <th>Description</th>
      </tr>
    </thead>
    <tbody>
      <ng-container
        *ngFor="let milestone of milestones_data; let index = index"
      >
        <tr>
          <td>
            <img
              src="assets/edit-client.png"
              class="page-table-actions"
              (click)="openPageOperationModal(milestone, 'Edit', index)"
            />
            <!-- Remove Delete <img
              src="assets/delete-icon.png"
              class="page-table-actions"
              class="page-table-actions"
              (click)="removeActivity(milestone, index)"
            /> -->
            <!-- <img src="assets/comments-doc.png" class="page-table-actions" (click)="openCommentsModal(milestone)" /> -->
          </td>
          <td [matTooltip]="milestone.name">{{ milestone.name }}</td>
          <td style="padding-top: 0">
            <img
              src="assets/ic-activities.png"
              class="page-table-actions"
              (click)="toggleMilestoneTasksView(index)"
            />
          </td>
          <td>{{ milestone.due_date | date: "dd-MMM-yyyy" }}</td>
          <td>{{ milestone.actual_date | date: "dd-MMM-yyyy" }}</td>
          <td>
            <span>{{ milestone.milestone_owner_name }}</span>
          </td>
          <td [matTooltip]="milestone.status_name">
            <span
              [ngClass]="{
                'milestone-status-pending': milestone.status_name == 'Pending',
                'milestone-status-progress':
                  milestone.status_name == 'In Progress',
                'milestone-status-completed':
                  milestone.status_name == 'Completed'
              }"
              >{{ milestone.status_name }}</span
            >
          </td>
          <td [matTooltip]="milestone.milestone_priority_name">
            {{ milestone.milestone_priority_name }}
          </td>
          <!-- <td [matTooltip]="milestone.description">{{milestone.description}}</td> -->
          <td [innerHTML]="milestone.description"></td>
        </tr>
        <tr *ngIf="show_milestone_tasks == index">
          <td colspan="9">
            <app-initiative-milestone-tasks
              [initiative_data]="initiative_data"
              [milestone_data]="milestone"
              [filters_data]="filters_data"
            ></app-initiative-milestone-tasks>
          </td>
        </tr>
      </ng-container>
      <tr>
        <td colspan="9">
          <span
            class="page-table-actions"
            (click)="openPageOperationModal(selected_page_data, 'Add', null)"
            >+ Add New Milestone</span
          >
        </td>
      </tr>
    </tbody>
  </table>
</div>

<ng-template #pageOperationsModal>
  <div class="page-modal-section">
    <div class="page-modal-heading-section">
      <span>{{ page_operation_type }} Milestone</span>
      <span
        class="page-modal-close-icon"
        (click)="closeActivityOperationModal()"
        >&times;</span
      >
    </div>
    <div class="page-modal-content-section">
      <div class="page-modal-input-section">
        <p class="page-modal-input-label">Milestone Name</p>
        <input
          type="text"
          class="page-modal-input"
          [(ngModel)]="selected_page_data.name"
        />
        <p
          class="page-modal-input-error"
          *ngIf="selected_page_data_errors.name"
        >
          Task Name is Required.
        </p>
      </div>
      <div class="page-modal-input-section">
        <p class="page-modal-input-label">Description</p>
        <!-- <textarea class="page-modal-input page-modal-textarea" [(ngModel)]="selected_page_data.description"></textarea> -->
        <app-textarea-tagging
          [value]="selected_page_data.description"
          [users]="tagging_users_list"
          [placeholder]="'Description ...'"
          (valueChanged)="selected_page_data.description = $event"
        ></app-textarea-tagging>
        <p
          class="page-modal-input-error"
          *ngIf="selected_page_data_errors.description"
        >
          Description is Required.
        </p>
      </div>
      <div class="page-modal-input-section">
        <p class="page-modal-input-label">Owner</p>
        <mat-select
          class="page-modal-input"
          [(ngModel)]="selected_page_data.milestone_owner"
        >
          <mat-option [value]="''">Select Owner</mat-option>
          <mat-option
            *ngFor="let owner of owners_list"
            [value]="owner.id"
            >{{ owner.first_name }} {{ owner.last_name }}</mat-option
          >
        </mat-select>
        <p
          class="page-modal-input-error"
          *ngIf="selected_page_data_errors.milestone_owner"
        >
          Owner is Required.
        </p>
      </div>
      <div class="page-modal-input-section">
        <p class="page-modal-input-label">Due date</p>
        <input
          type="text"
          class="page-modal-input"
          placement="left"
          bsDatepicker
          [(ngModel)]="selected_page_data.due_date"
          [bsConfig]="{ dateInputFormat: 'MM/DD/YYYY' }"
        />
        <p
          class="page-modal-input-error"
          *ngIf="selected_page_data_errors.due_date"
        >
          Due date is Required.
        </p>
      </div>
      <div class="page-modal-input-section">
        <p class="page-modal-input-label">Actual date</p>
        <input
          type="text"
          class="page-modal-input"
          placement="left"
          bsDatepicker
          [(ngModel)]="selected_page_data.actual_date"
          [bsConfig]="{ dateInputFormat: 'MM/DD/YYYY' }"
        />
        <p
          class="page-modal-input-error"
          *ngIf="selected_page_data_errors.actual_date"
        >
          Actual date is Required.
        </p>
      </div>
      <div class="page-modal-input-section">
        <p class="page-modal-input-label">Status</p>
        <mat-select
          class="page-modal-input"
          [(ngModel)]="selected_page_data.status"
        >
          <mat-option [value]="''">Select Status</mat-option>
          <mat-option *ngFor="let status of status_list" [value]="status.id">{{
            status.name
          }}</mat-option>
        </mat-select>
        <p
          class="page-modal-input-error"
          *ngIf="selected_page_data_errors.status"
        >
          Status is Required.
        </p>
      </div>
      <div class="page-modal-input-section">
        <p class="page-modal-input-label">Priority</p>
        <mat-select
          class="page-modal-input"
          [(ngModel)]="selected_page_data.milestone_priority"
        >
          <mat-option [value]="''">Select Priority</mat-option>
          <mat-option
            *ngFor="let priority of prority_list"
            [value]="priority.id"
            >{{ priority.name }}</mat-option
          >
        </mat-select>
        <p
          class="page-modal-input-error"
          *ngIf="selected_page_data_errors.milestone_priority"
        >
          Priority is Required.
        </p>
      </div>
      <div
        class="page-modal-heading-section"
        *ngIf="page_operation_type != 'Add'"
      >
        <span>Add Comments</span>
      </div>
      <div
        class="page-modal-input-section"
        *ngIf="page_operation_type != 'Add'"
      >
        <p class="page-modal-input-label">Date</p>
        <input
          type="text"
          class="page-modal-input"
          bsDatepicker
          [(ngModel)]="comment_data.comment_date"
          [bsConfig]="{ dateInputFormat: 'MM/DD/YYYY' }"
        />
        <p
          class="page-modal-input-error"
          *ngIf="comment_data_errors.comment_date"
        >
          Comment date is Required.
        </p>
      </div>
      <div
        class="page-modal-input-section"
        *ngIf="page_operation_type != 'Add'"
      >
        <p class="page-modal-input-label">Comments</p>
        <!-- <textarea class="page-modal-input page-modal-textarea" [(ngModel)]="comment_data.description"></textarea> -->
        <app-textarea-tagging
          [value]="comment_data.description"
          [users]="tagging_users_list"
          [placeholder]="'Comments ...'"
          (valueChanged)="comment_data.description = $event"
        ></app-textarea-tagging>
        <p
          class="page-modal-input-error"
          *ngIf="comment_data_errors.description"
        >
          Description is Required.
        </p>
      </div>
      <div
        class="page-modal-input-section"
        *ngIf="
          page_operation_type != 'Add' && selected_page_data.comments.length > 0
        "
      >
        <div class="page-modal-heading-section">
          <span>Comments</span>
        </div>
        <table class="comments-table">
          <thead>
            <tr>
              <th>Date</th>
              <th>Comments</th>
              <!-- Remove Delete <th>Action</th> -->
            </tr>
          </thead>
          <tbody>
            <tr
              *ngFor="
                let comment of selected_page_data.comments;
                let index = index
              "
            >
              <td>{{ comment.comment_date | date: "dd-MMM-yyyy" }}</td>
              <!-- <td>{{ comment.description }}</td> -->
              <td [innerHTML]="comment.description"></td>
              <!-- Remove Delete <td>
                <img
                  src="assets/delete-icon.png"
                  class="page-table-actions"
                  class="page-table-actions"
                  (click)="
                    deleteComment(selected_page_data.comments, comment, index)
                  "
                />
              </td> -->
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="page-modal-footer-section">
      <button class="page-modal-primary-button" (click)="saveTask()">
        Save
      </button>
      <button
        class="page-modal-secondary-button"
        (click)="closeActivityOperationModal()"
      >
        Cancel
      </button>
    </div>
  </div>
</ng-template>

<ng-template #activitiesDeleteModal>
  <div class="page-modal-section">
    <div class="page-modal-heading-section">
      <span>Delete Milestone Details</span>
      <span class="page-modal-close-icon" (click)="closeDeleteActivityModal()"
        >&times;</span
      >
    </div>
    <div class="page-modal-content-section">
      <p class="page-modal-delete-description">
        Are you sure you want to delete?
      </p>
    </div>
    <div class="page-modal-footer-section">
      <button class="page-modal-primary-button" (click)="deleteActivity()">
        Yes
      </button>
      <button
        class="page-modal-secondary-button"
        (click)="closeDeleteActivityModal()"
      >
        No
      </button>
    </div>
  </div>
</ng-template>

<ng-template #commentsModal>
  <div class="page-modal-section">
    <div class="page-modal-heading-section">
      <span>Comments</span>
      <span class="page-modal-close-icon" (click)="closeCommentsModal()"
        >&times;</span
      >
    </div>
    <div class="page-modal-content-section">
      <div
        class="page-modal-input-section"
        *ngIf="selected_page_data.comments.length > 0"
      >
        <table class="comments-table">
          <thead>
            <tr>
              <th>Date</th>
              <th>Comments</th>
              <!-- Remove Delete <th>Action</th> -->
            </tr>
          </thead>
          <tbody>
            <tr
              *ngFor="
                let comment of selected_page_data.comments;
                let index = index
              "
            >
              <td>{{ comment.comment_date | date: "dd-MMM-yyyy" }}</td>
              <td>{{ comment.description }}</td>
              <!-- Remove Delete <td>
                <img
                  src="assets/delete-icon.png"
                  class="page-table-actions"
                  class="page-table-actions"
                  (click)="
                    deleteComment(selected_page_data.comments, comment, index)
                  "
                />
              </td> -->
            </tr>
          </tbody>
        </table>
      </div>
      <div class="page-modal-heading-section">
        <span>Add Comments</span>
      </div>
      <div class="page-modal-input-section">
        <p class="page-modal-input-label">Date</p>
        <input
          type="text"
          class="page-modal-input"
          bsDatepicker
          [(ngModel)]="comment_data.comment_date"
          [bsConfig]="{ dateInputFormat: 'MM/DD/YYYY' }"
        />
        <p
          class="page-modal-input-error"
          *ngIf="comment_data_errors.comment_date"
        >
          Schedule date is Required.
        </p>
      </div>
      <div class="page-modal-input-section">
        <p class="page-modal-input-label">Comments</p>
        <textarea
          class="page-modal-input page-modal-textarea"
          [(ngModel)]="comment_data.description"
        ></textarea>
        <p
          class="page-modal-input-error"
          *ngIf="comment_data_errors.description"
        >
          Description is Required.
        </p>
      </div>
    </div>
    <div class="page-modal-footer-section">
      <button class="page-modal-primary-button" (click)="saveComment()">
        Save
      </button>
      <button
        class="page-modal-secondary-button"
        (click)="closeCommentsModal()"
      >
        Cancel
      </button>
    </div>
  </div>
</ng-template>

<ng-template #statusModal>
  <div class="page-modal-section">
    <div class="page-modal-heading-section">
      <span>Change Appointment Status</span>
      <span class="page-modal-close-icon" (click)="closeStatusModal()"
        >&times;</span
      >
    </div>
    <div class="page-modal-content-section">
      <div class="page-modal-input-section">
        <p class="page-modal-input-label">Appointment Status</p>
        <mat-select
          class="page-modal-input"
          [(ngModel)]="status_data.appointment_status"
        >
          <mat-option [value]="''">Select Appointment Status</mat-option>
          <mat-option
            *ngFor="let appointment_status of appointment_status_list"
            [value]="appointment_status.id"
            (click)="
              status_data.appointment_status_name = appointment_status.name
            "
            >{{ appointment_status.name }}</mat-option
          >
        </mat-select>
        <p
          class="page-modal-input-error"
          *ngIf="status_data_errors.appointment_status"
        >
          Appointment Status is Required.
        </p>
      </div>
      <div class="page-modal-input-section">
        <p class="page-modal-input-label">Appointment Reason</p>
        <textarea
          class="page-modal-input page-modal-textarea"
          [(ngModel)]="status_data.appointment_reason"
        ></textarea>
        <p
          class="page-modal-input-error"
          *ngIf="status_data_errors.appointment_reason"
        >
          Appointment Reason is Required.
        </p>
      </div>
    </div>
    <div class="page-modal-footer-section">
      <button class="page-modal-primary-button" (click)="saveStatus()">
        Save
      </button>
      <button class="page-modal-secondary-button" (click)="closeStatusModal()">
        Cancel
      </button>
    </div>
  </div>
</ng-template>
